<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { userInfo } from "../common/user-info"
import ContentPayableMixin from "./ContentPayableMixin"; 
import { router, findDefaultChannelOfTypeForRally, generateCustomFieldJSON, STRIPE_PUBLISHABLE_KEY} from "../common";
import { loadStripe } from '@stripe/stripe-js';
import { nextTick } from 'vue';
import moment from "moment";
import { eventBus } from "../main.js";
import {waitForElement} from "@/common";
export default {
// mixins: [ContentPayableMixin],
  data: function() {
    return {
      cardFees: true,
      loadAttempted: false,
      checkoutMode: false,
      participantList: [], 
      participantListsBySku: {},
      stripeToken: "",
      addInfo: "",
      notes: "",
      //publishableKey: "pk_test_51DLYQSF3WHnNQL2Jfw7ewSqfpFOKJqc8we7lWdT5QBkKgYSNKaJevvccsF4Ig98Eq3qvd3hsGzgz9l3D47n3VDCY00bcBvrsOy",
      skuString: "",
      oldConfirm: "",
     // fundraiser: null,
      //user_id: null,
      modalStatus: false,
      confirmStatus: false,
      state: null, // <--- This should come from the participation record, and is referenced by cssClass() and label() below, but I was not really sure what the options were.
      payItEnabled: false,
      customFieldValues:{},
      elements: null,
      card: null,
      stripePaymentType: "card",
      _mountedClientSecret: null,     // <— track which clientSecret we’ve mounted for
      _lastSentPaymentType: null      // <— track last type we sent to backend
    };
  },
  async mounted() {
  },
  computed: {
    ...mapState("contents", ["allContentByContextTypeAndId", "contentById"]),
    ...mapState("rfins", ["pendingStripeTxByUserAndContentId", "stripeTxErrorsByTxId", "accountRallyById", "totalsBySkuId"]),    
    ...mapState("user", ["usersById"]),
    ...mapState("participations", ["participationById"]),
    ...mapState("shares", ["sharesByShareId"]),
    formattedFeesDisplay(){
      return this.stripeTx?.attributes["formatted-fees"] ? this.stripeTx?.attributes["formatted-fees"] : "0.00"
    },
    formattedTotalDisplay(){
      return this.stripeTx?.attributes["formatted-total"] ? this.stripeTx?.attributes["formatted-total"] : "0.00"
    },
    deadlineDate() { 
      let c = this.allContentByContextTypeAndId[this.contextId]
      if (c && c.filter){
       let de =  c.filter(function(s) {
         if (s.attributes.type == 'DeadlineEvent'){
           return s
         } 
       })
       if (de && de.length > 0){
         if (de[0].attributes['to-date']){
            return moment(de[0].attributes['to-date'], 'MM/DD/YYYY').subtract(1, "days");
         } else {
           return null
         }
       } else {
         return null
       }
      } else {
        return null
      }
    },
    isArchived() {
      return this.fundraiser &&
          this.fundraiser.attributes['status'] == 2
    },
    isPastDeadline() {
      return this.deadlineDate && this.deadlineDate.add(1, "days").isBefore()
    }, 
    taxable() {
      let c = this.allContentByContextTypeAndId[this.contextId]
      if (c && c.filter){
        let pt = c.filter(function(s) {
          return s.attributes.type == 'Payable' && s.attributes.taxable 
         })
        return (pt && pt.length > 0)
      } else {
        return false
      }
      //return this.allContentByContextTypeAndId[parseInt(this.contextId)];
    },
    taxableNoZipEntered(){
      return this.taxable && !this.taxZip
    },
    payables() {
      let c = this.allContentByContextTypeAndId[this.contextId]
      if (c && c.filter){
       return c.filter(function(s) {
        return s.attributes.type == 'Payable'
       })
      } else {
        return []
      }
      //return this.allContentByContextTypeAndId[parseInt(this.contextId)];
    },
    currentUser() {
      return this.usersById[this.user_id];
    },
    confNum() {
      return this.oldConfirm
      /*var tx = this.pendingStripeTxByUserAndContentId[this.user_id + "" + this.contextId];
      if (tx) {
        return this.rallyId + "-" + tx.id;
      } else {
        return "Processing...";
      }*/
    },
    invalid() {
      return false
    },
    stripeTxKey() {
      return this.user_id + "" + this.contextId;
    },
    user_id() {
      return userInfo().user_id
    },
    stripeClientSecret(){
      return this?.stripeTx?.attributes["stripe-client-secret"];
    },
    stripeTx() {
      return this.pendingStripeTxByUserAndContentId[this.user_id + "" + this.contextId];
    },
    stripeTxId(){
      return this.stripeTx?.id
    },
    cssClass() {
      if (!this.isStripeAccountPresent && !this.allPayablesFree){
        return "hollow"
      }
      if (this.isArchived) {
        return 'warning'
      }
      switch (this.state + "") {
        case "1":
          return "warning";
        case "2":
          return "hollow";
        default:
          return "primary";
      }
    },
    label() {
      if (this.isArchived) {
        return 'Archived'
      }
      if (this.isPastDeadline || (!this.isStripeAccountPresent && !this.allPayablesFree)){ 
        return "Disabled"
      }
      switch (this.state + "") { 
        case "1":
          return "I'm Going";
        case "2":
          return "Holding My Spot";
        default:
          return (this.iHazPurchaz) ? "PURCHASE MORE": "REGISTER"; 
      }
    },
    accountRallyId(){
      //var payablez = this.allContentByContextTypeAndId[this.contextId]
      if (this.payables && this.payables.length > 0){
          return this.payables[0].attributes['account-rally-id']
      }
      return null;
    },
    accountRally(){
      return this.accountRallyById[this.accountRallyId]
    },
    publishableKey(){
      return  this.accountRally &&  this.accountRally.attributes && this.accountRally.attributes['publishable-key'] ? this.accountRally.attributes['publishable-key'] : STRIPE_PUBLISHABLE_KEY()
    }, 
    isStripeAccountPresent(){
      console.log("account rally is ")
      console.log(this.accountRally)
      return (this.accountRally && this.accountRally.attributes.title !== "Draft Account") ? true :false
    },

    registered() {
      return this.state !== null;
    },
    allFree(){
      return this?.stripeTx?.attributes["formatted-total"] === "0.00" ? true : false
    },
    fundraiser() {
        return this.contentById[this.contextId];
    },
    iHazPurchaz() {
      //let payablez = this.allContentByContextTypeAndId[this.contextId]
      let haz = false
      if (this.payables){
          this.payables.forEach(p => {
            if (this.getMyPurchaseById(p.id)){
              haz = true;
            }
        })
      }
      return haz;
    },
    iHazIntrez() {
      let haz = false;
     // let payablez = this.allContentByContextTypeAndId[this.contextId]
      if (this.payables){
          this.payables.forEach(p => {
            if (this.getInterestPart(p.id)){
              haz = true;
            }
        })
      }
      return haz;
    },
    allPayablesFree() {
      //let payablez = this.allContentByContextTypeAndId[this.contextId]
      let amount = 0
      if (this.payables && this.payables.forEach){
          this.payables.forEach(p => {
           amount = amount + p.attributes.cost
        })
      }
      return amount == 0;
    },
    channelId() {
      if (this.rallyChannelsByRallyId && this.rallyChannelsByRallyId[parseInt(this.rallyId)]) {
        var chanid = findDefaultChannelOfTypeForRally(
          this.channelTypePlural,
          this.rallyChannelsByRallyId,
          this.rallyId
        );
        return chanid
      } else {
        return null
      }
    },
    customFields(){
      if (this.allContentByContextTypeAndId[this.contextId] ) {
        let carr = this.allContentByContextTypeAndId[this.contextId]
        //console.log("carr is")
        //console.log(carr)
        let cf = []
        carr.forEach(c => {
          //console.log("carr")
          //console.log(c)
          //console.log("c.attributes.type")
          //console.log(c.attributes.type)
          //console.log("c.body")
          //console.log(c.attributes.body)
          if (c.attributes.type && c.attributes.type == "PaymentCustomFieldsDefinition" && c.attributes.body){
            try {
              cf = JSON.parse(c.attributes.body)["custom_field_definitions"]
              //console.log("cf")
              //console.log(cf)
            } catch (e){
              console.log(e)
            }
          }
        });
        return cf
      } 
      return null

    }
  },
  watch: {
    allContentByContextTypeAndId: function(newMap, oldMap) {
       if (newMap && newMap[parseInt(this.contextId)] && newMap[parseInt(this.contextId)].length > 0) {
        if (!this.stripeTx){
          //no transaction yet...
          let c = newMap[parseInt(this.contextId)]
          let pbles = []
          if (c && c.filter){
            pbles =  c.filter(function(s) {
              return s.attributes.type == 'Payable'
            })
          }
          //this.createStripeTx(pbles)
        }
      }
    },
    pendingStripeTxByUserAndContentId(newMap) {
      const tx = newMap[this.user_id + "" + this.contextId];
      if (!tx) return;

      // Handle success/processing transition once
      const status = tx.attributes["transaction-status"];
      if (status === "pay" || status === "pending_payment") {
        if (tx) this.oldConfirm = this.rallyId + "-" + tx.id;
        this.checkoutMode = false;
        this.participantList = [];
        this.stripeToken = "";
        this.notes = "";
        this.addInfo = "";
        this.customFieldsArr = [];
        this.toggleConfirm();
        this.myReloadPageData();
        // No need to re-mount here
        return;
      }

      // Only (re)mount if the client secret changed
      const cs = tx.attributes["stripe-client-secret"];
      if ((!cs) || (cs && this._mountedClientSecret !== cs)) {
        this.mountStripe();
      }
    }
  },

  methods: {
    ...mapActions("contents", ["fetchContents", "fetchContentById", "createContents"]),
    ...mapActions("rfins", ["createStripeTransaction", "updateStripeTransaction","fetchFundraiserDetails","fetchTotals"]),
    ...mapActions("rallies", ["rallyChannelsByRallyId"]),


    soldOut(p){
       return this.calcMaxTickets(p) == 0
    },
    calcMaxTickets(p){
      let max = 0
      //let amt = p.attributes["amount"];
      let maxp = p.attributes["max-participants"];
      //let totp = p.attributes["participant-total"];
      var newtot = this.totalsBySkuId[parseInt(p.attributes["sku-id"])]
      if (!newtot){
        newtot = 0 
      }
      if (!p.attributes["infinite-inventory"]) {

          max = parseInt(maxp) - parseInt(newtot);
      } else {
        max =  11
      }
      return max
    },

    customFieldName(n){
      return "custom_field_" + n
    },
    customFieldValueObject(n){
      if (!this[n]){
        this[n] = ""
      }
      return this[n]
    },

    getMyPurchaseById(id) {
      return this.user_id ? this.participationById[id + "purchased" + this.user_id] : null
    }, 
    getInterestPart(id) {
      return this.user_id ? this.participationById[id + "interested" + this.user_id] : null;
    },
    loadContents() {
      if (!this.contentById[this.contextId] ||  !(this.payables) || this.payables.size == 0) {
        this.myFetchContents()
        this.loadAttempted = true;
      }
    },
    loadPageData() {
      try {
        this.myReloadPageData()
        this.loadContents();
      } catch (e) {
        console.log(e);
      }
    },
    async mountStripe() {

    const stripe = await loadStripe(this.publishableKey, { stripeAccount: this.accountRally.attributes["account-id"] });
    this.stripe = stripe;
    //old school sripe component load
    if ( !this.stripeClientSecret ) {
        console.log("loading old school stripe component")
        // Default to old, card-only method during rollout
        const elements = this.stripe.elements();
        const card = elements.create('card');
        card.mount('#stripe-element-mount-point');
        this.card = card;
        return 
    }
    const cs = this.stripeClientSecret;
    if (!cs) return;

    // guard: already mounted for this client secret
    if (this._mountedClientSecret === cs) return;


    const appearance = {};
    const options = { layout: { type: 'tabs', defaultCollapsed: false } };
    const elements = this.stripe.elements({ clientSecret: cs, appearance });
    const card = elements.create('payment', options);
    card.mount('#stripe-element-mount-point');

    // remember what we mounted for
    this._mountedClientSecret = cs;
    this.elements = elements;
    this.card = card;

    // attach listener once
    card.on('change', this.onStripeElementChange);
  },

  onStripeElementChange(event) {
    const newType = event.value?.type; // 'card' | 'us_bank_account' | etc.

    // If no actual type change, bail
    if (!newType || newType === this.stripePaymentType) return;

    this.stripePaymentType = newType;

    // Don’t spam the store if we already sent this same type
    if (this._lastSentPaymentType === newType) return;
    this._lastSentPaymentType = newType;

    // Only update if there’s a selection to price
    const ss = [];
    this.payables?.forEach(p => {
      if (p.quantitySelected > 0) {
        ss.push(p.attributes["sku-id"] + ":" + p.quantitySelected + ":" + p.relationships["context-share"].data.id);
      }
    });
    if (ss.length === 0) return;

    this.skuString = ss.join(",");

    this.updateStripeTransaction({
      stripeTransactionId: this.stripeTx.id,
      accountRallyId: this.payables[0].attributes["account-rally-id"],
      contentUid: this.contextId,
      payableId: this.payables[0].attributes.id,
      shareId: this.fundraiser.relationships["context-share"].data.id,
      shareChannel: this.sharesByShareId[this.fundraiser.relationships["context-share"].data.id]?.attributes['context-channel-id'],
      skuArray: ss,
      transactionStatus: "", // just a pricing update
      rallyId: this.rallyId,
      notes: this.notes,
      addInfo: this.addInfo,
      contactPhone: this.currentUser?.attributes['phone'] || "",
      customFields: generateCustomFieldJSON(this.customFields, this.customFieldsArr),
      taxZip: this.taxZip,
      stripePaymentType: this.stripePaymentType
    });
    },
    async mountStripeold() {
      const stripe = await loadStripe(this.publishableKey, { stripeAccount: this.accountRally.attributes["account-id"]});
      this.stripe = stripe;

      if ( this.stripeClientSecret ) {
        // New method that supports ACH
        const appearance = { /* appearance */ };
        const clientSecret = this.stripeClientSecret;
        const options = {
          layout: {
            type: 'tabs',
            defaultCollapsed: false,
          }
        };
        const elements = this.stripe.elements({ clientSecret, appearance });
        const card = elements.create('payment', options);
        card.mount('#stripe-element-mount-point');

        card.on('change', (event) => {
          console.log('Payment method type changed:', event.value?.type);
          if (event.value?.type === 'us_bank_account' &&  event.value?.type != this.stripePaymentType ) {
            console.log('User selected ACH bank transfer');
            this.stripePaymentType = 'us_bank_account'
          } else if (event.value?.type === 'card' &&  event.value?.type != this.stripePaymentType) {
            this.stripePaymentType = 'card'
            console.log('User selected card');
          } else {
            //no change...return
            console.log("no stripepaymenttype change...returning")
            return 
          }
            ///
            
            var ss = [];
            this.payables.forEach(p => {
              if (p.quantitySelected && p.quantitySelected > 0) {
                ss.push(p.attributes["sku-id"] + ":" + p.quantitySelected + ":" + p.relationships["context-share"].data.id);
              }
            });
            if (ss.length > 0) {
              this.skuString = ss.join(",");
              this.updateStripeTransaction({
                stripeTransactionId: this.stripeTx.id,
                accountRallyId: this.payables[0].attributes["account-rally-id"],
                contentUid: this.contextId,
                payableId: this.payables[0].attributes.id,
                shareId: this.fundraiser.relationships["context-share"].data.id,
                shareChannel: this.sharesByShareId[this.fundraiser.relationships["context-share"].data.id]?.attributes['context-channel-id'],
                skuArray: ss,
                transactionStatus: "",
                rallyId: this.rallyId,
                notes: this.notes,
                addInfo: this.addInfo,
                contactPhone: this.currentUser?.attributes['phone'] ? this.currentUser?.attributes['phone'] : "",
                customFields:  generateCustomFieldJSON(this.customFields, this.customFieldsArr),
                taxZip: this.taxZip,
                stripePaymentType:  this.stripePaymentType
              });
              //this.createCustomFields()
            }
              
            ////
            //onChangeValue(event)
          
        })
        this.elements = elements;
        this.card = card;
      } else {
        // Default to old, card-only method during rollout
        const elements = this.stripe.elements();
        const card = elements.create('card');
        card.mount('#stripe-element-mount-point');
        this.card = card;
      }
    },
    async submitStripePayment() {
      console.log("submitting payment 1")
      if (!this.stripe || !this.elements) return;
      console.log("submitting payment 2")
      console.log(this.currentUser?.attributes['first-name'] + " " + this.currentUser?.attributes['last-name'])// + this.userInfo()?.email)
      const { error, paymentIntent } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name:  this.currentUser?.attributes['first-name'] + " " + this.currentUser?.attributes['last-name'],
              //email:  "jaytop@rallyhood.com"//this.userInfo()?.email,
            },
          },
        },
        redirect: 'if_required',
      });
      console.log("submitting payment 3")
      if (error) {
        console.log('Payment error:', error.message);
        // Show error in UI
      //} else if (paymentIntent.status === 'succeeded') {
       // console.log('Payment succeeded!', paymentIntent);
        // Trigger backend update, show success UI
      } else {
        console.log( paymentIntent);
        this.payItTokenCallback("", paymentIntent)
      }
    },

    myFetchContents() {
      console.log("content load mixin")
      this.loadAndCreate();
    },
    myReloadPageData() {
      if (userInfo()){
        this.fetchContents({
          ignorePagination: true,
          contentType: "Payable", 
          contextId: this.contextId,
          contextRallyId: this.rallyId,
          contextType: "Content",
          include: ["shares", "participations"],
          type: "Payable",
          rallyId: this.rallyId
        })

        try {
        this.fetchContents({
          ignorePagination: true,
          contentType: "Event", 
          contextId: this.content.id,
          contextRallyId: this.rallyId,
          contextType: "Content",
          include: ["shares"],
          type: "DeadlineEvent",
          rallyId: this.rallyId
        })
        } catch (e){
           console.log(e)
        }
        
        /*this.fetchContentById({
          id: this.contextId,
          contextChannelId: "308357",
          contentType: "Fundraiser"
        });*/
      } 
      else {
        router.push(`/login`);
        location.reload()
      }
    },
    loadAndCreate() {
      this.payItEnabled = true
      //if (this.payables && this.payables.length > 0) {
       // this.createStripeTx(this.payables)
     // }
    },
    createStripeTx(plist){
        //clear out the prior selection
        plist.forEach(p => {
          p.quantitySelected = 0;
        });
        this.createStripeTransaction({
          accountRallyId: plist[0].attributes["account-rally-id"],
          contentUid: this.contextId,
          payableId: plist[0].attributes.id,
          shareId: this.fundraiser.relationships["context-share"].data.id,
          shareChannel: this.sharesByShareId[this.fundraiser.relationships["context-share"].data.id]?.attributes['context-channel-id'],
          rallyId: this.rallyId,
          customFields: this.customFields
        });
    },
    createCustomFields(){
      try{

        if (this.customFields && this.customFields.length > 0){
          let cfields = {custom_fields:[]}
          this.customFields.forEach(c => {
            let v = this[this.customFieldName[c.name]]
            let cfield = {name: c.name, value: v}
            cfields.custom_fields.push(cfield)
          });
          return JSON.stringify(cfields)
          //let  chanid = this.sharesByShareId[this.fundraiser.relationships["context-share"].data.id]?.attributes['context-channel-id']
          //this.createContents({  title:"Custom Fields",  type: "PaymentCustomFields", contentType: "Message", rallyId: this.rallyId,  contextChannelId: chanid, contextRallyId:  this.rallyId, body: JSON.stringify(cfields)});
             /* MSF.model(:content).create(context_id: @payment.id,
                                        context_channel_id: @fundraiser.context_share.context_channel_id,
                                        context_type: 'Payment',
                                        context_rally_id: @rally.id,
                                        content_type: 'Message',
                                        type: 'PaymentCustomFields',
                                        title: 'Custom Fields',
                                        body: cust_field_json,
                                        creator_id: user_id)*/
        } else {
          return null 
        }
      } catch (e){
        console.log(e)
      }

    },

    stripeCardError(e){
        eventBus.emit('overlayOff')
    },

    payItTokenCallback(token, pIntent) { 
      this.stripeToken = token;
      var ss = [];
      this.payables.forEach(p => {
        if (p.quantitySelected && p.quantitySelected > 0) {
          ss.push(p.attributes["sku-id"] + ":" + p.quantitySelected + ":" + p.relationships["context-share"].data.id);
          p.attributes["amount"];
          let amt =  p.attributes["amount"]
          let totp = p.attributes["participant-total"]
          p.attributes["amount"] = parseInt(amt) - parseInt(p.quantitySelected)
          p.attributes["participant-total"] = parseInt(totp) + parseInt(p.quantitySelected)
        }
      });
      if (ss.length > 0) {
        console.log("generateCustomFieldJSON2")
        console.log(this.customFields)
        console.log(this.customFieldsArr)
        console.log(generateCustomFieldJSON(this.customFields, this.customFieldsArr))
        //alert(generateCustomFieldJSON(this.customFields, this.customFieldsArr))
        this.skuString = ss.join(",");
        this.updateStripeTransaction({ 
          stripeTransactionId: this.stripeTx.id,
          accountRallyId: this.payables[0].attributes["account-rally-id"],
          contentUid: this.contextId,
          payableId: this.payables[0].attributes.id,
          shareId: this.fundraiser.relationships["context-share"].data.id,
          shareChannel: this.sharesByShareId[this.fundraiser.relationships["context-share"].data.id]?.attributes['context-channel-id'],
          skuArray: ss,
          transactionStatus: pIntent ? "pending_payment" : "pay",
          stripePaymentToken: this.stripeToken  ? this.stripeToken.id: "",
          participantList: this.participantList,
          rallyId: this.rallyId,
          notes: this.notes,
          addInfo: this.addInfo,
          taxZip: this.taxZip,
          customFields: generateCustomFieldJSON(this.customFields, this.customFieldsArr),
          contactPhone: this.currentUser?.attributes['phone'] ? this.currentUser?.attributes['phone'] : ""
        });
        
      }
    },
    /*mapPaymentIntentStatus(pIntent){
      console.log("pintent status " + pIntent.status)
       if (pIntent.status === 'succeeded') {
          return "processing"
       } else {
          return "failed"
       }
    },*/
    onChangeValue(e) {
      //call rfins for updated totals, etc
      //"1472:1:10134819"
      console.log("onChangeValue...")
      var ss = [];
      this.payables.forEach(p => {
        if (p.quantitySelected && p.quantitySelected > 0) {
          ss.push(p.attributes["sku-id"] + ":" + p.quantitySelected + ":" + p.relationships["context-share"].data.id);
        }
      });
      if (ss.length > 0) {
        this.skuString = ss.join(",");
        console.log("generateCustomFieldJSON")
        console.log(this.customFields)
        console.log(this.customFieldsArr)
        console.log(generateCustomFieldJSON(this.customFields, this.customFieldsArr))
        this.updateStripeTransaction({
          stripeTransactionId: this.stripeTx.id,
          accountRallyId: this.payables[0].attributes["account-rally-id"],
          contentUid: this.contextId,
          payableId: this.payables[0].attributes.id,
          shareId: this.fundraiser.relationships["context-share"].data.id,
          shareChannel: this.sharesByShareId[this.fundraiser.relationships["context-share"].data.id]?.attributes['context-channel-id'],
          skuArray: ss,
          transactionStatus: "",
          rallyId: this.rallyId,
          notes: this.notes,
          addInfo: this.addInfo,
          contactPhone: this.currentUser?.attributes['phone'] ? this.currentUser?.attributes['phone'] : "",
          customFields:  generateCustomFieldJSON(this.customFields, this.customFieldsArr),
          taxZip: this.taxZip,
          stripePaymentType: this.stripePaymentType
        });
        //this.createCustomFields()
      }
    },

    checkout() {
      console.log("CHECK OUT!!")
      this.payables.forEach(p => {
        if (p.quantitySelected && p.quantitySelected > 0) {
          var listBySku = [];
          var skuId = p.attributes["sku-id"];
          for (var i = 0; i < p.quantitySelected; i++) {
            var newPart = { id: skuId + "_" + i, firstName: "", lastName: "", email: "", skuId, ticketName: p.attributes.title };
            this.participantList.push(newPart);
            listBySku = [...listBySku, newPart];
          }
        }
        this.participantListsBySku[skuId] = listBySku;
      });
      this.checkoutMode = true;
      console.log("CHECKOUT MODE... " + this.checkoutMode)
    },
    async payIt() {
      this.payItEnabled = false
      eventBus.emit('overlayOn')

      if ( this.stripeClientSecret ) {
        //new stripe element is active
        this.submitStripePayment()
        /*this.elements.submit().then((_result) => {
          console.log("_result")
          console.log(_result)
          this.submitStripePayment()
        });*/
      } else if (!this.allFree){
        //this.$refs.elementRef.submit();
        //const card = this.$refs.elementRef
        console.log(this.card)
        //const { token, error } = await card.submit(); 
        const { token, error } = await this.stripe.createToken(this.card);
        if (error) {
          alert('Payment error:', error.message);
        } else {
          console.log('Token received:', token.id);
          this.payItTokenCallback(token); // or send to backend
        }
      } else {
        //free tickets
        this.payItTokenCallback("")
      }
    },
    available(cost) {
      return Number(cost.total) - Number(cost.sold);
    },
    destroy() {
      // Do the thing
      this.toggleModal(); 
    },
    save() {
      // Do the thing
      this.toggleModal();
    },
    async fetchAllTotals() {
      if (this.payables) {
        await Promise.all(
          this.payables.map(p =>
            this.fetchTotals({
              fundraiserId: this.contextId,
              rallyId: this.rallyId,
              skuId: p.attributes["sku-id"],
            })
          )
        );
      }
    },
    toggleModal() {
      if (this.isPastDeadline || (!this.isStripeAccountPresent && !this.allPayablesFree)){ 
        return 
      }
      if (this.payables && this.payables.length > 0) {
        console.log("creating tx!!")
        this.createStripeTx(this.payables)
      }
      this.modalStatus = !this.modalStatus;
      this.confirmStatus = false;
    },
    toggleConfirm() {
      this.modalStatus = false;
      eventBus.emit('overlayOff')
      if (this.confirmStatus){
        this.fetchAllTotals()
        this.loadAndCreate()
      }
      this.confirmStatus = !this.confirmStatus;
    },
    log(message) {
      this.$log.debug(message);
    }
  }
};
</script>
